// import { useLanguage } from "../utils/languageContext";
import { useState, useEffect } from "react";
import { Link, useNavigate } from 'react-router-dom';
import Logo from '../../assets/LogoNeuHell.png';
import { useAlert } from "../../hooks/useAlert";
import axios from 'axios';
import { useMobile } from '../../utils/mobileContext';

const API_URL = process.env.REACT_APP_API_URL;

const AdminNavbar = () => {
    const isMobile = useMobile(1000);
    const [menuOpen, setMenuOpen] = useState(false);
    const navigate = useNavigate();
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    // eslint-disable-next-line 
    const [dashmenu, setDashmenu] = useState(false);
    const { showAlert } = useAlert();


    // Auth-Status vom Backend abrufen
    useEffect(() => {
        const checkAuthStatus = async () => {
            try {
                const res = await axios({
                    method: 'GET',
                    url: `${API_URL}/users/auth/status`,
                    withCredentials: true
                });
                setIsAuthenticated(!!res.data.user);
            } catch (error) {
                showAlert("Fehler beim Abrufen des Auth-Status", 'error');
                setIsAuthenticated(false);
            }
        };
        checkAuthStatus();
    }, []);

    const toggleMenu = () => {
        setMenuOpen(prev => !prev);
    };

    const handleLogout = async () => {
        try {
            await axios.get(`${API_URL}/users/logout`, {
                withCredentials: true
            });
            setIsAuthenticated(false);
            showAlert('Erfolgreich ausgeloggt', 'success');
            setTimeout(() => navigate('/'), 1000);
        } catch (error) {
            showAlert('Logout fehlgeschlagen', 'error');
        }
    };

    const handleDashmenu = () => {
        setDashmenu(prev => !prev);
    };

    return (
        <nav>
            <div className='logoContainer'>
                <img src={Logo} style={{ width: '250px' }} alt='Logo' />
            </div>

            {isMobile && (
                <div className="hamburger" onClick={toggleMenu}>
                    ☰
                </div>
            )}

            <ul className={`navList ${isMobile && menuOpen ? "open" : ""}`}>
                <li><Link to='/'>Startseite</Link></li>
                <li><Link to='/about'>Über uns</Link></li>
                {!isAuthenticated && <li><Link to='/login'>Anmelden</Link></li>}
                <li><Link to='/pricing'>Preise</Link></li>
                {isAuthenticated && <li onClick={handleDashmenu}><Link to='/admin/dashboard'>Dashboard</Link></li>}
                {isAuthenticated && <li onClick={handleLogout}>Logout</li>}
            </ul>
        </nav>
    );
};

export default AdminNavbar;